<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
   <div>
       <div class="page-content">
           <div class="container-fluid">

               <div class="row">
                   <div class="col-12 mb-4">
                       <v-card>
                           <v-card-title>
                               Gestion des pharmacies
                               <v-spacer></v-spacer>
                               <v-text-field
                                       v-model="search"
                                       append-icon="mdi-magnify"
                                       label="Rechercher ..."
                                       single-line
                                       hide-details
                               ></v-text-field>
                           </v-card-title>
                           <v-data-table
                                   :headers="headers"
                                   :items="pharmacies"
                                   :search="search"
                                   sort-by="name"
                                   class="elevation-1"
                                   :loading="pharmacieloading" loading-text="Chargement en cours...">

                               <template v-slot:item.code="{ item }">
                                   <v-chip  dark>{{ item.code }}</v-chip>
                               </template>
                               <template v-slot:item.quartier="{item}">
                                   {{item.quartier.nom}}
                               </template>

                               <template v-slot:top>
                                   <v-toolbar flat color="white">
                                       <v-spacer></v-spacer>
                                       <v-dialog v-model="dialog"  style="z-index: 9999" max-width="1000px">
                                           <template v-slot:activator="{ on }">
                                               <v-btn style="background: #2A3042;color: #fff" class="mb-2" v-on="on">Nouvelle pharmacie
                                               </v-btn>
                                           </template>
                                           <v-card>
                                               <v-card-title>
                                                   <span class="headline">{{ formTitle }}</span>
                                               </v-card-title>

                                               <v-card-text>

                                                   <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                  
                                                     <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Pharmacie</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">Administrateur par défaut</v-stepper-step>

      <v-divider></v-divider>

    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card
          class="mb-12"
          
        >
<v-row>
         <v-col cols="12" sm="6" md="6">
                <v-text-field
                @keyup="validestep(1)"
                  clearable :rules="nomRules" v-model="editedItem.nom"
                  label="Nom" placeholder="ex : Zoca">
                </v-text-field>

          </v-col>
           
                    <v-col cols="12" sm="6" md="6">
                                                                   <v-text-field
                                                                   @keyup="validestep(1)"
                                                                           clearable :rules="proprietaireRules" v-model="editedItem.proprietaire"
                                                                           label="Propriétaire" placeholder="ex : AKAN Joseph"></v-text-field>
                                                               </v-col>
                                                               </v-row>

                                                                <v-row>
                                                               <v-col cols="12" sm="6" md="6" >
                                                                   <v-select :rules="quartierRules" @change="validestep(1)"   v-model="editedItem.quartier" item-text="nom" item-value="_id" :items="quartiers" label="Quartier"  persistent-hint>

                                                                   </v-select>
                                                               </v-col>
                                                               

                                                               
                                                               <v-col cols="12" sm="6" md="6">
                                                                   <v-select
                                                                          @change="validestep(1)" 
                                                                           :rules="gardeRules"
                                                                           v-model="editedItem.night_open"
                                                                           :items="items"
                                                                           label="Garde"
                                                                           persistent-hint

                                                                   ></v-select>
                                                               

                                                               </v-col>
                                                               </v-row>

                                                                <div class="row" >
                                                                       <div class="col-md-6">
                                                                           <v-text-field
                                                                           @keyup="validestep(1)"
                                                                                   clearable :rules="phonepharmaRules" v-model="editedItem.phonepharma"
                                                                                   label="Téléphone" placeholder="ex : 22969587412" type="number"></v-text-field>
                                                                       </div>
                                                                       <div class="col-md-6">
                                                                           <v-text-field
                                                                           @keyup="validestep(1)"
                                                                                   clearable :rules="ifuRules" v-model="editedItem.ifu"
                                                                                   label="IFU" placeholder="ex : 1234567893652" type="number"></v-text-field>
                                                                       </div>

                                                                   </div>


                                                                   <div class="row" >
                                                                       <div class="col-md-6">
                                                                           <v-text-field
                                                                           @keyup="validestep(1)"
                                                                                   clearable :rules="latitudeRules" v-model="editedItem.latitude"
                                                                                   label="Latitude" placeholder="ex : 6.157845" type="number"></v-text-field>
                                                                       </div>
                                                                       <div class="col-md-6">
                                                                           <v-text-field
                                                                           @keyup="validestep(1)"
                                                                                   clearable :rules="longitudeRules" v-model="editedItem.longitude"
                                                                                   label="Longitude" placeholder="ex : 2.285423" type="number"></v-text-field>
                                                                       </div>

                                                                   </div>

                                                                   <div class="row" >
                                                                       <div class="col-md-12">
                                                                           <v-text-field
                                                                           @keyup="validestep(1)"
                                                                                   clearable :rules="sloganRules" v-model="editedItem.slogan"
                                                                                   label="Slogan" placeholder="ex : At vero eos et accusam et justo duo dolores" ></v-text-field>
                                                                       </div>
                                                                   </div>

                                                               

        </v-card>

        <div class="col-md-12 text-right">
              <v-btn
                color="primary"
                @click="e1 = 2"
                :disabled="!step1valide"
              >
                Continuer
              </v-btn>

              
        </div>

      
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card
          class="mb-12"
          
        >

         <v-text-field v-if="submitting" color="primary" loading
                                                                     disabled></v-text-field>
          <v-row>

              <v-col cols="12" sm="6" md="6">
                                                                   <v-text-field
                                                                           @keyup="validestep(2)"
                                                                           clearable :rules="nameRules" v-model="editedItem.name"
                                                                           label="Nom complet" placeholder="ex : Patrick SODJINNIN"></v-text-field>
                                                               </v-col>
                                                               <v-col cols="12" sm="6" md="6">
                                                                   <v-text-field
                                                                          @keyup="validestep(2)"
                                                                           clearable :rules="emailRules" v-model="editedItem.email"
                                                                           label="Email" placeholder="ex : sodjinninpatrick@gmail.com" type="email"></v-text-field>
                                                               </v-col>

          </v-row>

          <v-row>

              <v-col cols="12" sm="6" md="6">
                                                                <v-text-field
                                                                      @keyup="validestep(2)"
                                                                       clearable :rules="phoneRules" v-model="editedItem.phone"
                                                                       label="Téléphone" placeholder="ex : +22996587565" type="number"></v-text-field>
                                                                 </v-col>

                                                                   <v-col cols="12" sm="6" md="6">
                                                                       <v-text-field
                                                                              @keyup="validestep(2)"
                                                                               :rules="passwordRules"
                                                                               :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                                               :type="show1 ? 'text' : 'password'"
                                                                               @click:append="show1 = !show1"
                                                                               clearable v-model="editedItem.password"
                                                                               label="Mot de passe" placeholder="******"></v-text-field>
                                                               </v-col>

          </v-row>




        </v-card>

        

        
         <div class="col-md-12 text-right">
              <v-btn
                color="primary"
                :disabled="!step2valide"
                @click="save"
              >

                Enregistrer
              </v-btn>

              <v-btn text @click="e1 = 1">Retour</v-btn>

              
        </div>
      </v-stepper-content>

      
    </v-stepper-items>
  </v-stepper>
   </v-form>

                                               </v-card-text>
                                           </v-card>
                                       </v-dialog>
                                       <v-dialog v-model="update" max-width="500px">
                                           <v-card>
                                               <v-card-title>
                                                   <span class="headline">{{ formTitle }}</span>
                                               </v-card-title>

                                               <v-card-text>
                                                   <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                       <v-alert v-if="errors" dense outlined
                                                                :type="(errors.update_error)?'error':'success'">
                                                           {{errors.operation}}
                                                       </v-alert>

                                                       <v-text-field v-if="submitting" color="primary" loading
                                                                     disabled></v-text-field>
                                                       <v-row>
                                                               <v-col cols="12" sm="6" md="12">
                                                                   <v-text-field
                                                                           clearable :rules="nomRules" v-model="editedItem.nom"
                                                                           label="Nom" placeholder="ex : Zoca"></v-text-field>
                                                               </v-col>
                                                               <v-col cols="12" sm="6" md="12">
                                                                   <v-text-field
                                                                           clearable :rules="proprietaireRules" v-model="editedItem.proprietaire"
                                                                           label="Propriétaire" placeholder="ex : AKAN Joseph"></v-text-field>
                                                               </v-col>
                                                               <v-col cols="12" sm="6" md="12" >
                                                                   <v-select :rules="quartierRules" @change="quartierChanged"   v-model="editedItem.quartier" item-text="nom" item-value="_id" :items="quartiers" label="Quartier"  persistent-hint>

                                                                   </v-select>
                                                               </v-col>
                                                               <v-col cols="12" sm="6" md="12">
                                                                   <v-select
                                                                           :rules="gardeRules"
                                                                           v-model="editedItem.night_open"
                                                                           :items="items"
                                                                           label="Garde"
                                                                           persistent-hint
                                                                   ></v-select>
                                                               </v-col>
                                                               <div class="row" >
                                                                   <div class="col-md-6">
                                                                       <v-text-field
                                                                               clearable :rules="latitudeRules" v-model="editedItem.latitude"
                                                                               label="Latitude" placeholder="ex : 8.15" type="number"></v-text-field>
                                                                   </div>
                                                                   <div class="col-md-6">
                                                                       <v-text-field
                                                                               clearable :rules="longitudeRules" v-model="editedItem.longitude"
                                                                               label="Longitude" placeholder="ex : 4.20" type="number"></v-text-field>
                                                                   </div>

                                                               </div>

                                                       </v-row>
                                                   </v-form>
                                               </v-card-text>

                                               <v-card-actions>
                                                   <v-spacer></v-spacer>
                                                   <v-btn color="blue darken-1" text @click="closed">Annuler</v-btn>
                                                   <v-btn color="blue darken-1"  text @click="updated">Sauvegarder</v-btn>
                                               </v-card-actions>
                                           </v-card>
                                       </v-dialog>
                                   </v-toolbar>
                               </template>
                               <template v-slot:item.actions="{ item }">
                                   <v-icon small class="mr-2" @click="editItem(item)">
                                       mdi-pencil
                                   </v-icon>
                                   <v-icon small @click="deleteItem(item)">
                                       mdi-delete
                                   </v-icon>
                               </template>
                               <template v-slot:no-data>
                                   <v-btn color="default" @click="initialize">Actualiser</v-btn>
                               </template>
                           </v-data-table>
                       </v-card>
                   </div>
               </div>
               <v-snackbar
                       v-model="snackbar"
                       timeout="2000"
               >
                   {{ textSnack }}

                   <template v-slot:action="{ attrs }">
                       <v-btn
                               color="blue"
                               text
                               v-bind="attrs"
                               @click="snackbar = false"
                       >
                           Fermer
                       </v-btn>
                   </template>
               </v-snackbar>

           </div> <!-- container-fluid -->
       </div>
       <!-- End Page-content -->

   </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";

    export default {
        name: "Pharmacie",
        data() {
            return {
                e1:1,
                submitting: false,
                step1valide:false,
                step2valide:false,
                valid: true,
                lazy: false,
                quartierHasChanged:false,
                errors:undefined,
                search: '',
                dialog: '',
                update: '',
                id: undefined,
                snackbar: false,
                textSnack: '',
                show1: false,
                items: ['Oui', 'Non'],
                headers: [
                    {
                        text: 'Nom',
                        align: 'start',
                        sortable: true,
                        value: 'nom',
                    },
                    {text: 'Propriétaire', value: 'proprietaire'},
                    {text: 'Quartier', value: 'quartier'},
                    {text: 'Garde', value: 'night_open'},
                    {text: 'Latitude', value: 'latitude'},
                    {text: 'Longitude', value: 'longitude'},
                    {text: 'Actions', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    nom: '',
                    proprietaire: '',
                    quartier:'',
                    night_open:'',
                    latitude:'',
                    longitude:'',
                    phonepharma:'',
                    ifu:'',
                    slogan:'',
                    name:'',
                    email:'',
                    phone:'',
                    password:'',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    nom: '',
                    proprietaire: '',
                    quartier:'',
                    night_open:'',
                    latitude:'',
                    longitude:'',
                    phonepharma:'',
                    ifu:'',
                    slogan:'',
                    name:'',
                    email:'',
                    phone:'',
                    password:'',
                    _id: 0,
                    created_at: 0,
                },
                nomRules: [
                    v => !!v || 'Nom de la pharmacie est requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                proprietaireRules: [
                    v => !!v || 'Nom du proprietaire requis',
                ],
                quartierRules: [
                    v => !!v || 'Quartier requis',
                ]
                ,
               gardeRules: [
                    v => !!v || 'Garde requis',
                ],

                latitudeRules: [
                v => !!v || 'Latitude requis',
            ],

                longitudeRules: [
                v => !!v || 'Longitude requis',
            ],
                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                emailRules: [
                    v => !!v || 'Email requis',
                ]
                ,
                passwordRules: [
                    v => !!v || 'Mot de passe requis',
                ],

                phoneRules: [
                    v => !!v || 'Téléphone requis',
                ],

                sloganRules: [
                    v => !!v || 'Sloagan requis',
                ],
                ifuRules: [
                    v => !!v || 'IFU requis',
                ],
                phonepharmaRules: [
                    v => !!v || 'Numéro pharmacie requis',
                ]

                

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle pharmacie" : "Mise à jour"
            }
            ,
            ...mapState('pharmacies/', ['pharmacies','pharmacieloading']),
            ...mapState('quartiers/', ['quartiers'])

        }
        ,
        mounted() {
            this.$store.dispatch('pharmacies/getPharmacie').then(response => {
                window.console.log('pharmacies', response)
            });
            this.$store.dispatch('quartiers/getQuartier').then(response => {
                window.console.log('quartiers', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
            update(val) {
                val || this.closed()
            }
        }
        ,
        methods: {
            initialize() {

            },
            validestep(step){

                switch(step){

                    case 1:{

                        let listchamp = [ 'nom',
                        'proprietaire',
                        'quartier',
                        'night_open',
                        'latitude',
                        'longitude',
                        'phonepharma',
                        'ifu',
                        'slogan'];
                       
                        for(let i=0; i<listchamp.length; i++)
                        {
                            console.log(listchamp[i],this.editedItem[listchamp[i]]);
                            if (this.editedItem[listchamp[i]]=='')
                            {
                                this.step1valide = false;
                                break;
                            }else{
                                
                                  this.step1valide = true;
                               
                                
                            }
                        }


                      break;
                      }

                  case 2:{

                     let listchamp = [  'name',
                    'email',
                    'phone',
                    'password'];
                       
                        for(let i=0; i<listchamp.length; i++)
                        {
                            console.log(listchamp[i],this.editedItem[listchamp[i]]);
                            if (this.editedItem[listchamp[i]]=='')
                            {
                                this.step2valide = false;
                                break;
                            }else{
                                this.step2valide = true;
                            }
                        }


                     break;
                     }

                }

            }
            ,
            quartierChanged(){
                this.quartierHasChanged = true;
            },

            editItem(item) {
                this.editedIndex = this.pharmacies.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.update = true;
                this.id = item._id;

            }
            ,

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('pharmacies/deletePharmacie', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                 this.dialog = false;

                this.$refs.form.reset()
                this.$store.dispatch('pharmacies/getPharmacie').then(response => {
                    window.console.log('pharmacies', response)
                });
               

            },
            closed() {
                this.$store.dispatch('pharmacies/getPharmacie').then(response => {
                    window.console.log('pharmacies', response)
                });
                this.$refs.form.reset()
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.update = false;
                this.quartierHasChanged = false;



            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("nom", this.editedItem.nom);
                data.append("proprietaire", this.editedItem.proprietaire);
                data.append("quartier", this.editedItem.quartier);
                data.append("garde", this.editedItem.night_open);
                data.append("ifu", this.editedItem.ifu);
                data.append("slogan", this.editedItem.slogan);
                data.append("phonepharma", this.editedItem.phonepharma);
                data.append("latitude", this.editedItem.latitude);
                data.append("longitude", this.editedItem.longitude);
                data.append("name", this.editedItem.name);
                data.append("email", this.editedItem.email);
                data.append("phone", this.editedItem.phone);
                data.append("password", this.editedItem.password);
                let mineroute = 'pharmacies/setPharmacie';
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                        this.$refs.form.reset()

                    }
                })
            },
            updated() {
                this.submitting = true;
                let data = new FormData();
                data.append("nom", this.editedItem.nom);
                data.append("proprietaire", this.editedItem.proprietaire);
                data.append("garde", this.editedItem.night_open);
                data.append("latitude", this.editedItem.latitude);
                data.append("longitude", this.editedItem.longitude);
                data.append("id",this.editedItem._id);
                if ( this.quartierHasChanged){
                    data.append("quartier",this.editedItem.quartier);
                }
                let mineroute = 'pharmacies/setPharmacie';
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.closed();

                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(){
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>